import gql from 'graphql-tag';
import { convertFilterRequestUrl } from 'utils/utils';
import adjustmentNS from './constants/adjustmentNS';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, adjustmentNS)}` : '';
  const searchArOpsRequests = `searchArOpsRequests(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${searchArOpsRequests} {
        id
        accountId
        userId
        itemId
        invoiceId
        startDate
        source
        reason
        type
        amount
        percent
        customReason
        crDrType
        parentId
        status
        action
      }
    }
  `;
};
